import {
  default as MuiModal,
  type ModalProps as MuiModalProps,
  modalClasses as muiModalClasses,
} from '@mui/material/Modal';

/**
 * @deprecated Unsupported component: This is an internal component, use Dialog instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const Modal = MuiModal;
/**
 * @deprecated Unsupported component: This is an internal component, use Dialog instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type ModalProps = MuiModalProps;
/**
 * @deprecated Unsupported component: This is an internal component, use Dialog instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const modalClasses = muiModalClasses;
